{
  "name": "@jun133/kitty",
  "version": "0.0.19",
  "description": "Agent",
  "license": "MIT",
  "keywords": [
    "kitty",
    "agent",
    "automation",
    "runtime",
    "harness"
  ],
  "bin": {
    "kitty": "dist/cli.js"
  },
  "files": [
    "dist",
    "README.md",
    "scripts/postinstall.cjs"
  ],
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "scripts": {
    "build": "tsup src/cli.ts --format cjs --platform node --target node20 --outDir dist --clean --sourcemap && tsup src/tui.ts --format esm --platform node --target node20 --outDir dist --clean=false --external typescript",
    "check": "npm run typecheck && npm run build",
    "dev": "tsx src/cli.ts",
    "test:build": "node -e \"require('node:fs').rmSync('.test-build', { recursive: true, force: true })\" && tsc -p tsconfig.tests.json",
    "test:core": "npm run test:build && node scripts/run-core-tests.mjs",
    "test:eval": "npm run test:build && node --test .test-build/tests/evaluation/**/*.test.js",
    "eval:local": "node scripts/ensure-dist-built.mjs && node dist/cli.js eval --run-local",
    "eval:production": "node scripts/ensure-dist-built.mjs && node dist/cli.js eval --run-production",
    "verify": "npm test",
    "typecheck": "tsc --noEmit",
    "postinstall": "node scripts/postinstall.cjs",
    "prepublishOnly": "npm run build",
    "test": "npm run check && npm run test:core"
  },
  "dependencies": {
    "better-sqlite3": "^12.8.0",
    "chalk": "^5.6.2",
    "commander": "^14.0.1",
    "diff": "^8.0.2",
    "dotenv": "^17.2.3",
    "execa": "^9.6.0",
    "fast-glob": "^3.3.3",
    "figlet": "^1.11.0",
    "ink": "^7.1.0",
    "marked": "^15.0.7",
    "openai": "^6.4.0",
    "react": "^19.2.7",
    "string-width": "^8.2.1",
    "wrap-ansi": "^10.0.0",
    "ws": "^8.21.0"
  },
  "devDependencies": {
    "@types/better-sqlite3": "^7.6.13",
    "@types/node": "^24.5.2",
    "@types/react": "^19.2.17",
    "@types/ws": "^8.18.1",
    "tsup": "^8.5.0",
    "tsx": "^4.20.5",
    "typescript": "^5.9.2"
  }
}
